export default {
    addButton: 1,
    updateButton: 2,
    cancelButton: 4,
    confirmButton: 8,
    addDefault: 1 | 4,
    updateDefault: 2 | 4,
    lookDefault: 8
}